import { TextField } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import StatusLabel from '../../common/components/StatusLabel';
import { sortStudentsByRollNo } from './studentRollNoUtils';

export const StudentRollNoTableColumns = (
  onRollNoChange: (id: string, rollNo: string) => void
): GridColDef[] => {
  return [
    {
      field: 'profile',
      headerName: 'Student Photo',
      flex: 1,
      disableExport: true,
      renderCell: (params) => {
        return (
          <img
            src={params.row.profile}
            alt=''
            style={{ width: '40px', height: '40px', borderRadius: '50%' }}
          />
        );
      }
    },
    { field: 'name', headerName: 'Name', flex: 1 },
    {
      field: 'gender',
      headerName: 'Gender',
      flex: 1
    },
    {
      field: 'enrollmentNo',
      headerName: 'Enrollment no',
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        return <StatusLabel status={params.value} />;
      }
    },
    {
      field: 'rollNo',
      headerName: 'Roll No',
      width: 250,
      sortComparator: sortStudentsByRollNo,
      renderCell: (params) => {
        return (
          <TextField
            value={params.value || ''}
            onChange={(e) => onRollNoChange(params.row.id, e.target.value)}
            sx={{
              height: '40px',
              width: '100px',
              flex: 1,
              '& .MuiInputBase-root': {
                height: '40px',
                width: '100px  !important',
                boxSizing: 'border-box'
              }
            }}
            inputProps={{
              style: {
                height: '40px',
                boxSizing: 'border-box',
                padding: '0 14px'
              }
            }}
          />
        );
      }
    }
  ];
};
